export default {
  MISCGCS: 'MISCGCs',
  RTD_COOKIE_NAME: 'RTD',
  STATE_COOKIE_NAME: 'USERST',
  SHIPPING_COUNTRY_COOKIE_NAME: 'shippingCountry',
  ZIP_CODE_COOKIE_NAME: 'USERPC',
  CUSTOMER_ID_COOKIE_NAME: 'macys_online_uid',
  HEADER_SEPARATOR: '@',
  DEFAULT_HEADER_TEXT: 'you might also like...',
  DEFAULT_FCC_CATEGORY_ID: 118,
  PATH_RTO_RECOMMENDATIONS: '/sdp/rto/request/recommendations',
  PATH_FCC_RECOMMENDATIONS: '/api/catalog/v2/categories/CATEGORY_ID/products?returnNavigationProductPool=true&_limit=15&_offset=1',
  FCC_SORT_ORDER: {
    FEATURED_ITEMS: 'ORIGINAL',
    BEST_SELLERS: 'BEST_SELLERS',
    CUSTOMER_TOP_RATED: 'CUSTOMER_RATING',
    NEW_ARRIVALS: 'NEWNESS',
    PRICE_ASCENDING: 'PRICE_ASCENDING',
    PRICE_DESCENDING: 'PRICE_DESCENDING',
  },
  CLASS_SELECTOR: '.prosPanel',
  MULTITAB_SELECTOR: '.pros-horizontal-multi-tab',
  CLASS_SELECTOR_CLASS: 'prosPanel',
  ID_SELECTOR: '#prosPanel',
  THUMBNAIL_SELECTOR: '.productThumbnail',
  PAGE: {
    HOME_PAGE: 'HOME_PAGE',
    SEARCH_PAGE: 'SEARCH_PAGE',
    BROWSE_PAGE: 'BROWSE_PAGE',
    CAT_SPLASH_PAGE: 'CAT_SPLASH_PAGE',
    PURCHASE_HISTORY_PAGE: 'PURCHASE_HISTORY_PAGE',
    PURCHASE_DETAIL_PAGE: 'PURCHASE_DETAIL_PAGE',
    RESPONSIVE_BAG: 'RESPONSIVE_BAG',
  },
  SB_ZONES: {
    SB_ZONE_A: 'SB_ZONE_A',
    SB_ZONE_B: 'SB_ZONE_B',
    SB_ZONE_C: 'SB_ZONE_C',
  },
  DEVICE: {
    DESKTOP: 'DESKTOP',
    PHONE: 'PHONE',
  },
  MAX_HEADER_LENGTH: 50,
  SHIP_IT: 'ship it',
  VIEW_TYPE: {
    CAROUSEL: 'carousel',
    GRID: 'grid',
  },
  ORIENTATION: {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
  },
  CAROUSEL_TYPE: {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
    COLORSWATCHES: 'colorswatches',
  },
  CAROUSEL_SWATCHES_BUTTON_WIDTH: 25,
  CAROUSEL_ITEM_TOTAL_PADDING: {
    LARGE: 20,
  },
  BREAK_POINTS: {
    SMALL: 600,
    MEDIUM: 1024,
    LARGE: 1440,
  },
  RESPONSIVE_PROS_WIDTH: {
    SMALL: 180,
    MEDIUM: 228,
    LARGE: 230,
  },
  HEARTING_MSGS: {
    ADDED_TO_LIST: 'Added To List',
    REMOVED_FROM_LIST: 'Removed From List',
    UNABLE_TO_ADD: 'Unable To Add',
    UNABLE_TO_REMOVE: 'Unable To Remove',
  },
  SHOW_CAROUSEL_BREAKPOINT: 5,
  COMPARISON_CATEGORY_ID: 'attrId',
  COMPARISON_ATTRIBUTE_NAME: 'key',
  COMPARISON_PAGE_SIZE: 15,
  COMPARISON_TABLE_HEADER_TEXT: 'Compare with similar items',
  COOKIES: {
    THIRTHY_DAYS_IN_MS: 2592000000,
    MACHINE_ID: 'macys_online',
    USER_ID: 'macys_online_uid',
    BAG_GUID: 'macys_bagguid',
  },
};
